import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template", "participantItem"];

  static values = {
    participantIndex: { type: Number, default: 0 },
  };

  connect() {
    this.participantIndexValue = this.participantItemTargets.length;
  }

  addParticipant() {
    const template = this.templateTarget;
    const newParticipant = template.content.cloneNode(true);

    const newIndex = this.participantIndexValue;
    this.participantIndexValue += 1;

    this.updateParticipantFields(newParticipant, newIndex);

    this.containerTarget.appendChild(newParticipant);

    const firstNameField = this.containerTarget.lastElementChild.querySelector(
      'input[name*="[first_name]"]'
    );

    if (firstNameField) {
      firstNameField.focus();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  removeParticipant(event) {
    const participantItem = event.target.closest(".participant-item");
    if (participantItem) {
      participantItem.remove();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  updateParticipantFields(participantElement, index) {
    const formFields = participantElement.querySelectorAll(
      "input, select, textarea"
    );

    formFields.forEach((field) => {
      if (field.name) {
        field.setAttribute("name", field.name.replace(/\[\d+\]/, `[${index}]`));
      }

      if (field.id) {
        field.setAttribute("id", field.id.replace(/_\d+/, `_${index}`));
      }
    });

    const labels = participantElement.querySelectorAll("label");
    labels.forEach((label) => {
      if (label.htmlFor) {
        label.setAttribute("for", label.htmlFor.replace(/_\d+/, `_${index}`));
      }
    });

    const participantLabel = participantElement.querySelector("h3");
    if (participantLabel) {
      participantLabel.textContent = `Participant ${index + 1}`;
    }
  }
}
